import { useState } from "react";
import { Autoplay, Navigation, Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import useSlider from "../hooks/useSlider";
import { type SliderItem } from "../schema";
import "../swiperSlider.css";
import Loading from "./Loading";
import { useNavigate } from "react-router";

export default function Slider() {
  const [imgArr, isLoading] = useSlider(8);
  const [activeIndex, setActiveIndex] = useState<number>(-1);
  const sliderItems: SliderItem[] = [
    ...imgArr,

    {
      post_cover: "/images/cultivators/cultivators-slide.webp",
      title: "Cultivators Forum Lisbon 2023",
      title_slug: "cultivators-forum",
      type: "event-series",
      isDirectory: true,
    },
  ];
  const navigate = useNavigate();
  return (
    <div className="col-span-1 md:col-span-2 flex flex-col justify-start">
      {!isLoading ? (
        <Swiper
          modules={[Navigation, Pagination, Autoplay]}
          pagination={{ clickable: true }}
          slidesPerView={1}
          autoplay={{ delay: 3500, pauseOnMouseEnter: true }}
          speed={1000}
          loop={true}
          className="w-full flex items-center justify-center"
          onSlideChange={({ realIndex }) => setActiveIndex(realIndex)}
        >
          {sliderItems.map((item, index) => {
            return (
              <SwiperSlide
                key={index}
                title={item.title}
                onClick={() => navigate(`culture/${item.type}/${item.title_slug}`)}
                className="cursor-pointer"
              >
                <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-transparent to-transparent" />

                <h3
                  className={`absolute font-expandedBold text-white text-sm md:text-xl xl:text-2xl 3xl:text-3xl w-full px-6 lg:px-10 pt-4 lg:pt-6
                transition-transform duration-[2000ms] ease-in-out transform ${
                  activeIndex === index ? "translate-x-0 opacity-100" : "translate-x-full opacity-0"
                }`}
                >
                  {item.title}
                </h3>
                <img src={item.post_cover} alt={item.title} className="aspect-video w-full" />
              </SwiperSlide>
            );
          })}
        </Swiper>
      ) : (
        <div className="min-h-[50vh] sm:min-h-[70vh] flex items-center justify-center">
          <Loading />
        </div>
      )}
    </div>
  );
}
